import React from 'react';
import styled from 'styled-components';

import { Config } from '@front/common/src/types/commons';
import { isCountryGB } from '@front/common/src/utils/country';
import colors from '@front/common/src/utils/colors';

import { translate } from '@front/i18n';

import Text from '@front/web-ui/src/components/base-text/variants/text';
import SimpleLink from '@front/web-ui/src/components/link/simple-link';

const t = translate('screens.additional_information');

const StyledTextWithLink = styled.div`
  > p {
    display: inline;
    margin: 0;
  }
`;

const StyledCGU = styled(StyledTextWithLink)`
  margin-top: 20px;
`;

type CGUProps = {
  config?: Config;
};

const CGU = ({ config }: CGUProps) => {
  if (isCountryGB()) {
    return (
      <StyledCGU>
        <Text.SM htmlTag='p' color={colors.ink50}>
          {t('.cgu_label_1')}
        </Text.SM>
        <SimpleLink size='sm' type='tertiary' href={config?.routes.terms_of_service || '#'} openInNewTab>
          {t('.cgu_label_link_1')}
        </SimpleLink>
        <Text.SM htmlTag='p' color={colors.ink50}>
          {t('.cgu_label_3')}
        </Text.SM>
        <SimpleLink size='sm' type='tertiary' href={config?.routes.privacy_policy || '#'} openInNewTab>
          {t('.cgu_label_link_2')}
        </SimpleLink>
      </StyledCGU>
    );
  }

  return (
    <StyledCGU>
      <Text.SM htmlTag='p' color={colors.ink50}>
        {t('.cgu_label_1')}
      </Text.SM>
      <SimpleLink size='sm' type='tertiary' href={config?.routes.terms_of_service_care || '#'} openInNewTab>
        {t('.cgu_label_link_1')}
      </SimpleLink>
      <Text.SM htmlTag='p' color={colors.ink50}>
        {t('.cgu_label_2')}
      </Text.SM>
      <SimpleLink size='sm' type='tertiary' href={config?.routes.privacy_policy || '#'} openInNewTab>
        {t('.cgu_label_link_2')}
      </SimpleLink>
      <Text.SM htmlTag='p' color={colors.ink50}>
        {t('.cgu_label_3')}
      </Text.SM>
      <SimpleLink size='sm' type='tertiary' href={config?.routes.data_policy || '#'} openInNewTab>
        {t('.cgu_label_link_3')}
      </SimpleLink>
    </StyledCGU>
  );
};

export default CGU;
